import { useNavigate, type NavigateFunction, useLocation } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

const SITE_URL = 'https://vijing.sonbook.net';

function usePageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    let canonical = SITE_URL + '/';
    if (pathname === '/home') {
      canonical = SITE_URL + '/';
    } else if (pathname === '/') {
      canonical = SITE_URL + '/';
    } else {
      canonical = SITE_URL + pathname;
    }

    let link: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonical;
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  usePageMeta();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  return element;
}